import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="m13.87 18.293 2.441 10.62c.322 1.4 2.253 1.466 2.666.09l6.96-23.178c.35-1.168-.824-2.207-1.908-1.688L2.795 14.307c-1.256.6-.956 2.504.422 2.673l10.654 1.313z" clip-rule="evenodd" stroke="none"></path>';
export var LocationArrowSVG = function LocationArrowSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LocationArrowSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LocationArrowSVG);